import { useQuery as defaultUseQuery, useMutation as defaultUseMutation, } from "@apollo/react-hooks";
import { usePaymentSource } from "@zapier/payment";
import { useAccountCurrency, useCurrentAccountId, useOffer, usePromoPlans, } from "@zapier/promotions/esm/hooks";
import { getOfferIdFromUrl } from "./getOfferIdFromUrl";
export const useOfferModal = ({ offerId: offerIdProp, onAcceptOfferSuccess = () => {
}, ...props }) => {
    var _a;
    const useQuery = (props === null || props === void 0 ? void 0 : props.useQuery) || defaultUseQuery;
    const useMutation = (props === null || props === void 0 ? void 0 : props.useMutation) || defaultUseMutation;
    const { accountId } = useCurrentAccountId({ useQuery });
    const offerId = offerIdProp || getOfferIdFromUrl();
    const canShow = Boolean(accountId && !!offerId);
    const { acceptOffer, error, isLoading: isLoadingOffer, isOfferActive, isOfferAvailable, isSaving, offer, offerEndDate, } = useOffer({
        offerId,
        onAcceptOfferSuccess,
        useQuery,
        useMutation,
    });
    const { isLoading: isLoadingPaymentSource, primarySource, } = usePaymentSource({ accountId, useQuery });
    const { allowIntervalSelection, isLoading: isLoadingPromoPlans, promoPlans, } = usePromoPlans({ useQuery });
    const { currency: accountCurrency, isLoading: isCurrencyLoading, } = useAccountCurrency({ useQuery });
    const isLoading = isLoadingOffer ||
        isLoadingPaymentSource ||
        isLoadingPromoPlans ||
        isCurrencyLoading;
    return {
        acceptOffer,
        accountCurrency,
        allowIntervalSelection,
        error,
        isLoading,
        isOfferAvailable,
        isPaymentMethodProvided: Boolean(primarySource),
        isSaving,
        offer,
        offerEndDate,
        promoPlans,
        showModal: Boolean(!isLoading &&
            canShow &&
            !isOfferActive &&
            !((_a = offer === null || offer === void 0 ? void 0 : offer.variant) === null || _a === void 0 ? void 0 : _a.isControl)),
    };
};

// @zapier/upsells@5.0.1 (c64b11b3c)
